import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-col-md-12 q-text-muted popular-products__header q-p-0 q-m-0 q-fw-semibold" }




export default /*#__PURE__*/_defineComponent({
  __name: 'PromotedProductHeader',
  props: ['promotedProductHeader'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(__props.promotedProductHeader), 1))
}
}

})